export default __webpack_public_path__ + "static/media/swing_1_low.5f5a1d4c.svg";